import { useEffect } from 'react';

import { ignoreError } from '#/service/utils';
import { useAuthStore } from '#/store/auth/auth.store';
import { historyActions } from '#/store/history/history.store';

// watch for changes in the logged in and initialized state, and load/reset history accordingly.
export const useUpdateHistory = () => {
  const { isLoggedIn, isInitialised } = useAuthStore();

  useEffect(() => {
    if (isInitialised && isLoggedIn) {
      historyActions.loadAll().catch(ignoreError);
    } else {
      historyActions.reset();
    }
  }, [isInitialised, isLoggedIn]);
};
